export default __webpack_public_path__ + "static/media/Hikes.8c2ea950.svg";